import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[wdxFFWrappedControlHost]',
    standalone: false,
})
export class FormWrappedControlDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
